import Promise from 'promise-polyfill'
import "whatwg-fetch"
import mapValues from "lodash/mapValues"
import join from "lodash/join"
import extend from "lodash/extend"
import toArray from "lodash/toArray"
import { GetFilterParamsResponse } from "./GetFilterParamsResponse"
import { GetFilterFlatsResponse } from "./GetFilterFlatsResponse"
import { GetSectionDetailResponse } from "./GetSectionDetailResponse"
import { GetFlatResponse } from "./GetFlatResponse";
import { GetFloorDetailResponse } from "./GetFloorResponse"
import { AddFavoriteResponse } from "./AddFavoriteResponse";
import { RemoveFavoriteResponse } from "./RemoveFavoriteResponse";

if (!window.Promise) {
  window.Promise = Promise;
}

let preLoader = null;

function serializeParams(params) {
  return join(toArray(mapValues(params, (value, key) => key + "=" + value)), '&');
}

function request(url, params) {
  const query = serializeParams(params);

  if (preLoader) {
    preLoader.show()
  }

  return fetch(`${url}?${query}`, extend({}, {
    credentials: 'same-origin',
  })).then((response) => {
    if (preLoader) {
      preLoader.hide();
    }
    return response.json()
  });
}

/** @returns {Promise<GetFilterParamsResponse>} */
export function getFilterParams(api) {
  return request(api)
    .then((response) => {
      return new GetFilterParamsResponse(response)
    })
}

export function getFilterFlats(api, params) {
  return request(api, params)
    .then((response) => {
      return new GetFilterFlatsResponse(response);
    })
}

export function getFlat(api, params) {
  return request(api, params)
    .then((response) => {
      return new GetFlatResponse(response);
    })
}

export function getFloor(api, params) {
  return request(api, params)
    .then((response) => {
      return new GetFloorDetailResponse(response);
    })
}

export function getSection(api, params) {
  return request(api, params)
    .then((response) => {
      return new GetSectionDetailResponse(response)
    })
}

export function addFlatToFavorites(api, params) {
  return request(api, params)
    .then((response) => {
      return new AddFavoriteResponse(response)
    })
}

export function removeFlatFromFavorites(api, params) {
  return request(api, params)
    .then((response) => {
      return new RemoveFavoriteResponse(response)
    })
}

export function registerPreloader(newPreloader) {
  preLoader = newPreloader
}



// WEBPACK FOOTER //
// ./js/api/index.js